package app.nestbridge.domain.identity.model

import kotlinx.serialization.Serializable
import kotlin.time.Instant

@Serializable
data class UserProfile(
    val id: String,
    val userId: String,
    val fullName: String,
    val displayName: String,
    val profilePictureUrl: String? = null,
    val locale: String,
    val timezone: String,
    val createdAt: Instant,
    val createdBy: String,
    val modifiedAt: Instant,
    val modifiedBy: String,
) {
    companion object {
        val empty = UserProfile(
            id = "",
            userId = "",
            fullName = "",
            displayName = "",
            profilePictureUrl = null,
            locale = "en-US",
            timezone = "UTC",
            createdAt = kotlin.time.Clock.System.now(),
            createdBy = "",
            modifiedAt = kotlin.time.Clock.System.now(),
            modifiedBy = "",
        )
    }
}
